import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { Card, Table, TableActionsCell, renderTableHeader, } from '@wit-support/ui';
import { cn } from './lib/cn.js';
function isColumnList(props) {
    return props.headerCells !== undefined;
}
/**
 * The desktop-table / mobile-card-list pair that recurs verbatim across every
 * admin list page (channels, admins, classification topics, templates):
 *
 * ```
 * <Card className="hidden overflow-hidden md:block">
 *   <Table density="compact">…</Table>
 * </Card>
 * <ul className="flex flex-col gap-3 md:hidden">…</ul>
 * ```
 *
 * Only that skeleton is shared here — the columns (`header`), the per-row
 * cells (`renderRow`), and the per-item mobile card content
 * (`renderMobileCard`) stay with the caller via render props, so each list
 * page keeps rendering pixel-for-pixel what it rendered as inline JSX before
 * this extraction.
 */
export function ResponsiveTableList(props) {
    const { items, getKey, density = 'compact', renderRow, renderMobileCard, className } = props;
    const actionsColumn = isColumnList(props) ? props.actionsColumn : undefined;
    const header = isColumnList(props)
        ? renderTableHeader(props.headerCells, props.actionsColumn)
        : props.header;
    return (_jsxs(_Fragment, { children: [_jsx(Card, { className: cn('hidden overflow-hidden md:block', className), children: _jsxs(Table, { density: density, children: [header, _jsx(Table.Body, { children: items.map((item) => renderRow(item, actionsColumn ? (_jsx(TableActionsCell, { column: actionsColumn.column, children: actionsColumn.render(item) })) : null)) })] }) }), _jsx("ul", { className: "flex flex-col gap-3 md:hidden", children: items.map((item) => (_jsx("li", { children: renderMobileCard(item, actionsColumn ? actionsColumn.render(item) : null) }, getKey(item)))) })] }));
}
ResponsiveTableList.displayName = 'ResponsiveTableList';
/**
 * Карточка мобильной ветки `ResponsiveTableList` — `Card` с единым
 * `flex flex-col gap-2 p-4`. До выноса каждый список писал её сам, и обёртки
 * разошлись по зазору и размеру шрифта; отличия сайта (больший зазор,
 * `text-sm`, `opacity-50` архивной строки) — через `className`.
 */
export const ListCard = React.forwardRef(({ className, ...props }, ref) => (_jsx(Card, { ref: ref, className: cn('flex flex-col gap-2 p-4', className), ...props })));
ListCard.displayName = 'ListCard';
//# sourceMappingURL=responsive-table-list.js.map